/*!
 * classie v1.0.1
 * class helper functions
 * from bonzo https://github.com/ded/bonzo
 * MIT license
 *
 * classie.has( elem, 'my-class' ) -> true/false
 * classie.add( elem, 'my-new-class' )
 * classie.remove( elem, 'my-unwanted-class' )
 * classie.toggle( elem, 'my-class' )
 */

/* eslint-disable no-param-reassign */

// class helper functions from bonzo https://github.com/ded/bonzo
function classReg(className) {
  return new RegExp('(^|\\s+)' + className + '(\\s+|$)');
}

// classList support for class management
// altho to be fair, the api sucks because it won't accept multiple classes at once
let hasClass;
let addClass;
let removeClass;

if (typeof document !== 'undefined' && 'classList' in document.documentElement) {
  hasClass = function (elem, c) {
    return elem.classList.contains(c);
  };
  addClass = function (elem, c) {
    elem.classList.add(c);
  };
  removeClass = function (elem, c) {
    elem.classList.remove(c);
  };
} else {
  hasClass = function (elem, c) {
    return classReg(c).test(elem.className);
  };
  addClass = function (elem, c) {
    if (!hasClass(elem, c)) {
      elem.className = elem.className + ' ' + c;
    }
  };
  removeClass = function (elem, c) {
    elem.className = elem.className.replace(classReg(c), ' ');
  };
}

function toggleClass(elem, c) {
  const fn = hasClass(elem, c) ? removeClass : addClass;
  fn(elem, c);
}

const classie = {
  // full names
  hasClass,
  addClass,
  removeClass,
  toggleClass,
  // short names
  has: hasClass,
  add: addClass,
  remove: removeClass,
  toggle: toggleClass,
};

module.exports = classie;



// WEBPACK FOOTER //
// ./classie.jsx